import React from "react"
import { Helmet } from "react-helmet"
import styled from "styled-components"
import { graphql } from "gatsby"

import { Typography } from "@material-ui/core"

// import app components
import Textarea from "../../components/textarea"
import LinkBox from "../../components/_flexibleContent/LinkBoxes/LinkBox"

import Hero from "../../components/hero"
import SideBar from "../../components/SideBar"
import Edges from "../../components/_layout/edges"

import { Content, PageWrapper } from "../../container/layout/Layout"

export default function product(props) {
  const {
    wordsbyCollections: {
      post_title,
      post_content,
      featured_img,
      pathname,
      acf: { ...heroFields }
    },
    posts: { edges: posts }
  } = props.data

  return (
    <>
      <Helmet>
        <title>{post_title} - Fraserview Cedar Products</title>
      </Helmet>

      <Hero
        {...heroFields}
        autoPlay
        interval={10000}
        post_title={post_title}
        path={pathname}
        featuredImage={featured_img}
      />

      <Edges size="lg">
        <Content id="read-more">
          <SideBar />
          <PageWrapper>
            {heroFields?.hero_size !== "large" && post_title && (
              <Typography variant="h1">{post_title}</Typography>
            )}
            {!!post_content && <Textarea content={post_content} />}
            <Posts>
              {!!posts &&
                posts.map(({ node: post }) => {
                  return (
                    <LinkBox
                      style={{ marginBottom: "10px" }}
                      key={post.id}
                      to={post.pathname}
                      image={post.featured_img}
                      headline={post.post_title.replace(
                        "Western Red Cedar ",
                        ""
                      )}
                      count={posts.length}
                    />
                  )
                })}
            </Posts>
          </PageWrapper>
        </Content>
      </Edges>
    </>
  )
}

const Posts = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 80px;
`

export const CollectionQuery = graphql`
  query($skip: Int, $limit: Int, $post_type: String, $id: Int) {
    posts: allWordsbyCollections(
      filter: { post_type: { eq: $post_type } }
      skip: $skip
      limit: $limit
    ) {
      edges {
        node {
          id
          post_title
          post_content
          pathname
          featured_img {
            childImageSharp {
              fluid(maxWidth: 2560, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
          taxonomies {
            category {
              pathname
              terms {
                name
                slug
                pathname
              }
            }
          }
        }
      }
    }

    wordsbyCollections(ID: { eq: $id }) {
      post_title
      post_content
      pathname
      featured_img {
        childImageSharp {
          fluid(maxWidth: 2560, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      acf {
        ...heroContent
      }
    }
  }
`
